module.exports = __webpack_public_path__ + "static/img/icon-add.ec275be2.svg";